// 6. HOME PAGE
const HOME_PAGE_TEXT = {
    PAGE_TITLE: "Titolo SPA Template",
    PAGE_DESCRIPTION: "Seleziona un'operazione",
    MAIN_BTN_LABEL_NEW_PROCESS: "Bottone primario 1",
    MAIN_BTN_LABEL_MANAGEMENT_FILE: "Cards Page",
    MAIN_BTN_LABEL_PAPERWORKS_HISTORY: "Bottone primario 3",
};

// 6.1. Nuova Lavorazione
const NEW_PROCESS_PAGE_TEXT = {
    PAGE_TITLE: "Titolo",
    PAGE_DESCRIPTION: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.", // TODO: The description is WIP
    FORM_INSTANCE_FORMAT: "Radio button",
    FORM_PAPERWORK_TYPE: "Select",
    FORM_LICENSE_PLATE: "Input",
    FORM_LICENSE_PLATE_PLACEHOLDER: "Inserire il campo",
};

const ACTION_BAR_BUTTONS_TEXT = {
    EXIT: "Chiudi",
    CANCEL: "Annulla",
    RESET: "Reset",
    CONFIRM: "Conferma",
    TO_BACK: "Indietro",
    SEND: "Invia"
};

const COMPONENTS_TEXT = {
    DROPDOWN_COMPONENT_PLEASE_CHOOSE_ONE_OPTION: "Scegliere un'azione",
    SELECT_COMPONENT_NO_DATA_AVAILABLE: "Nessun dato trovato",
    SELECT_COMPONENT_LOADING: "Caricamento...",
    SELECT_COMPONENT_ERROR: "Errore",
    TABLE_MISSING_DATA: "Nessun Dato presente nella Tabella",
    SUCCESS_MSG: "Operazione eseguita correttamente",
};

const LAYOUT_TEXT = {
    LOGO_LABEL: "Titolo SPA Template",
    ROUTE_LBL_HOME: "Home",
    ROUTE_LBL_NEW_PROCESS: "Menu",
    ROUTE_LBL_DIRECTORY_MANAGEMENT: "Gestione Fascicoli",
    ROUTE_LBL_PAPERWORKS_HISTORY: "Storico Pratiche",
    ROUTE_LBL_CONSULTATION: "Consultazioni",
    ROUTE_LBL_SEARCH_INSTANCE: "Bottone secondario",
    ROUTE_LBL_END_OF_DAY: "Bottone secondario",
    ROUTE_LBL_CERTIFICATION: "Bottone secondario",
    ROUTE_LBL_PAYMENT_CONSULTATION: "Bottone secondario",
    FOOTER_ROUTE_LBL_PRIVACY_POLICY: "Privacy Policy",
    FOOTER_ROUTE_LBL_LEGAL_NOTICES: "Note Legali",
    FOOTER_ROUTE_LBL_MEDIA_POLICY: "Media Policy",
    FOOTER_ROUTE_LBL_CONTACTS: "Contatti",
    FOOTER_ROUTE_LBL_ACCESSIBILITY: "Accessibilità",
    FOOTER_ROUTE_LBL_ASSISTANCE: "Assistenza",
};

const MESSAGE_VALIDATION_FIELD = {
    REQUIRED: "The field is required",
    MINLENGTH: "Insert the minimum lunge",
    MIN: "Insert a value valid",
    MAX: "Insert a value valid"
};

const CARD_LABEL = {
    HIDDEN: "",
    LOCKED: "Bloccato",
    ACTIVE: "Attivo",
    ERROR: "Errore",
    COMPLETED: "Completato",
    WARNING: "Presentazione in corso",
};


export {
    HOME_PAGE_TEXT,
    NEW_PROCESS_PAGE_TEXT,
    ACTION_BAR_BUTTONS_TEXT,
    COMPONENTS_TEXT,
    LAYOUT_TEXT,
    MESSAGE_VALIDATION_FIELD,
    CARD_LABEL
};
